import React from 'react'

import Category from 'components/Category'
import Tooltip from 'components/Tooltip'

import constants from './constants'

import classes from './CategoryLeadersLabel.module.scss'

const CategoryLeadersLabel = () => {
  return (
    <Tooltip className="CategoryLeadersLabel" title={constants.title}>
      <div className={classes.badgeContainer}>
        <Category.LeaderBadge />
      </div>
    </Tooltip>
  )
}

export default CategoryLeadersLabel
